import templateSelection from '../../../../Template/config/components/selection'
import setBuilder from './SetBuilder'
import search from './Search'

export default {
    ...templateSelection,
    setBuilder,
    search
}


// WEBPACK FOOTER //
// ./src/app/configuration/Insurance/config/components/selection/index.js